import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface LoadingStateProps {
  message?: string;
  fullPage?: boolean;
  variant?: 'spinner' | 'skeleton' | 'cards';
  skeletonCount?: number;
}

export function LoadingState({ 
  message = 'Loading...', 
  fullPage = false,
  variant = 'spinner',
  skeletonCount = 5
}: LoadingStateProps) {
  const content = (
    <div className="flex flex-col items-center justify-center py-12">
      {variant === 'spinner' && (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
          <p className="text-sm text-muted-foreground">{message}</p>
        </>
      )}
      {variant === 'skeleton' && (
        <div className="w-full space-y-3">
          {Array.from({ length: skeletonCount }).map((_, i) => (
            <Skeleton key={i} className="h-12 w-full" />
          ))}
        </div>
      )}
      {variant === 'cards' && (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 w-full">
          {Array.from({ length: skeletonCount }).map((_, i) => (
            <Card key={i}>
              <CardContent className="pt-6">
                <Skeleton className="h-4 w-24 mb-2" />
                <Skeleton className="h-8 w-16 mb-2" />
                <Skeleton className="h-3 w-32" />
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
}

